// extracted by mini-css-extract-plugin
export var embedCode = "KpointPlayer-module--embedCode--6d61f";
export var image = "KpointPlayer-module--image--9b8eb";
export var kpointBlue = "KpointPlayer-module--kpoint-blue--9335f";
export var kpointGreen = "KpointPlayer-module--kpoint-green--87e4c";
export var kpointRed = "KpointPlayer-module--kpoint-red--0f9c8";
export var kpointSpinner = "KpointPlayer-module--kpoint-spinner--a21cf";
export var kpointSpinner__dot = "KpointPlayer-module--kpoint-spinner__dot--78179";
export var markupTemplateContainer = "KpointPlayer-module--markupTemplateContainer--f83ea";
export var notLoaded = "KpointPlayer-module--notLoaded--4ded6";
export var playerOverlay = "KpointPlayer-module--playerOverlay--77cf3";
export var spin78236 = "KpointPlayer-module--spin78236--e6c75";
export var thumbnail = "KpointPlayer-module--thumbnail--77b89";
export var videoContainer = "KpointPlayer-module--videoContainer--9610c";
export var wobble1 = "KpointPlayer-module--wobble1--ee87b";
export var wobble2 = "KpointPlayer-module--wobble2--44064";